import {
    Component,
    OnInit,
    ViewContainerRef,
    ElementRef
} from '@angular/core';

import { SharedService } from '../shared/shared.service';

@Component({
    selector: 'card-main-app',
    template: require('./card-main.component.html')
})

export class CardMainComponent implements OnInit {

    public hasAuthorized: boolean = this.elementRef.nativeElement.getAttribute('hasAuthorized') === 'hasAuthorized';
    public email: string = this.elementRef.nativeElement.getAttribute('email');
    public giftId: string = this.elementRef.nativeElement.getAttribute('giftId');
    public code: string = this.elementRef.nativeElement.getAttribute('code');

    showMessageForm = '';
    constructor(
        public vcRef: ViewContainerRef,
        private readonly elementRef: ElementRef,
        private sharedService: SharedService
    ) {
    }

    ngOnInit(): void {
        this.sharedService.hasAuthorized = this.hasAuthorized;
        this.sharedService.email = this.email;
        this.sharedService.giftId = this.giftId;
        this.sharedService.code = this.code;
    }
}






// WEBPACK FOOTER //
// ./src/app/card/components/card-main.component.ts